import { render, staticRenderFns } from "./channelLineList.vue?vue&type=template&id=94423ef2&scoped=true"
import script from "./channelLineList.vue?vue&type=script&lang=js"
export * from "./channelLineList.vue?vue&type=script&lang=js"
import style0 from "./channelLineList.vue?vue&type=style&index=0&id=94423ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94423ef2",
  null
  
)

export default component.exports